import { render, staticRenderFns } from "./TheSideMenu.vue?vue&type=template&id=75f9c7c8&scoped=true&"
import script from "./TheSideMenu.vue?vue&type=script&lang=ts&"
export * from "./TheSideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TheSideMenu.vue?vue&type=style&index=0&id=75f9c7c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f9c7c8",
  null
  
)

export default component.exports